// extracted by mini-css-extract-plugin
export default {"link":"PasswordReset_link__ztnqP","note":"PasswordReset_note__pbUF-","title":"PasswordReset_title__Ujo7Y","passwordReset":"PasswordReset_passwordReset__RKv5t"};